import api from './api';

export const supplierService = {
  // Tüm tedarikçileri getir
  getSuppliers: async () => {
    const response = await api.get('/api/business/suppliers');
    return response.data;
  },

  // Tek bir tedarikçiyi getir
  getSupplierById: async (id) => {
    const response = await api.get(`/api/business/suppliers/${id}`);
    return response.data;
  },

  // Tedarikçiye mail gönder (Menom üzerinden)
  sendSupplierEmail: async (supplierId, emailData) => {
    const response = await api.post(`/api/business/suppliers/${supplierId}/send-email`, emailData);
    return response.data;
  },

  // Kendi lead'lerimi getir
  getMyLeads: async () => {
    const response = await api.get('/api/business/suppliers/leads/my');
    return response.data;
  },
  
  // Tedarikçiyle anlaş
  agreeWithSupplier: async (supplierId, notes) => {
    const response = await api.post(`/api/business/suppliers/${supplierId}/agree`, { notes });
    return response.data;
  },
  
  // Tedarikçiyle anlaşmayı iptal et
  cancelAgreement: async (supplierId) => {
    const response = await api.delete(`/api/business/suppliers/${supplierId}/agree`);
    return response.data;
  }
};

